"use client";

import { type JSX } from "react";
import RichTextWithTable from "../../../molecules/RichTextWithTable/RichTextWithTables";
import { extractHiddenBlock } from "../../../utils/styles";
import { NoDataFallback } from "../../../utils/NoDataFallback";
import styles from "./RichText.module.scss";
import { RichTextProps } from "components/sxa/rich-text/rich-text.props";

export const Default = (props: RichTextProps): JSX.Element => {
  console.log("---->[RichText] Component", props.fields);

  const { fields, params } = props;

  if (!fields) {
    return <NoDataFallback componentName="Rich Text" />;
  }

  const stylesArray = params?.Styles?.split(" ") ?? [];
  const hasTextWhite = stylesArray.includes("text-white");
  const has8xl = stylesArray.includes("text-8xl");

  const titleTextColor = hasTextWhite
    ? "text-white"
    : "text-ecolab-blue-two [&_*]:text-ecolab-blue-two";

  const titleStyles = has8xl
    ? `${titleTextColor} px-4 pt-[52px] pb-8 text-[56px] [&_*]:text-[56px]! lg:[&_*]:text-8xl! leading-[0.84] [&_*]:leading-[0.84]! lg:leading-[76.8px] lg:[&_*]:leading-[76.8px]! tracking-[0.4px] lg:tracking-[0.8px] font-medium [&_*]:font-medium lg:text-center font-["Special_Gothic_Condensed_One"] [&_*]:font-["Special_Gothic_Condensed_One"] [&_*]:mt-0! [&_*]:mb-4! `
    : "leading-[1.5] text-base";

  const id = params?.RenderingIdentifier;
  const styleClass = `${params?.Styles?.trimEnd() ?? ""} ${titleStyles}`;
  const hiddenBlockStyles = extractHiddenBlock(params?.GridParameters);

  return (
    <div
      className={`richtext-component relative px-4 pb-3 overflow-hidden ${styleClass} ${styles.richTextContainer} ${hiddenBlockStyles}`}
      id={id || undefined}
      data-role="rich-text-component"
    >
      <div className="max-w-full">
        <RichTextWithTable field={fields.Text} />
      </div>
    </div>
  );
};